import {
    GRANULAR_SLA_MANAGEMENT_PATH,
    ROOT_PATH, SITE_ID_PARAM_NAME,
} from 'src/core/config/navigationRoutes';


export function getGranularSLAPath( siteId: string )
{
    return GRANULAR_SLA_MANAGEMENT_PATH.replace( `:${SITE_ID_PARAM_NAME}`, siteId );
}